export const GET_BOOK_LOADING="GET_BOOK_LOADING"
export const GET_BOOK_SUCCESS="GET_BOOK_SUCCESS"
export const GET_BOOK_ERROR="GET_BOOK_ERROR"


export const LOGIN_LOADING="LOGIN_LOADING"
export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_ERROR="LOGIN_ERROR"

export const LOGOUT_SUCCESS="LOGOUT_SUCCESS"